module.exports = __WEBPACK_EXTERNAL_MODULE_25__;


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 25
// module chunks = 1